import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'
import ExternalLink from '../../common/external-link'
import { ChevronRightIcon } from '../../common/icons'

export const Container = styled.div`
    width: 100%;
`

export const SliderContainer = styled.div<{ $isVisible: boolean }>`
    position: ${props => props.theme.style.position.relative};
    max-width: 100%;
    margin-top: 0.5rem;
    display: ${props => (props.$isVisible ? 'block' : 'none')};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 1rem;
    }
`

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string; center?: boolean }>`
    width: 100%;
    margin: ${({ margin }) => (!!margin ? margin : 0)};
    li {
        list-style: none;
    }
    ${({ center }) =>
        center
            ? `& > .carousel__slider {
            padding-right: 1rem;
        }`
            : ''}
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        padding: 0;
        overflow: hidden;
        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }

        .carousel__slider-tray {
            display: flex; /* required for gap to work */
            gap: 1rem;
        }
    `,
)

export const ColumnBox = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.tfwBlack10};
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.white};
`

export const RegionItem = styled(ExternalLink)`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0.25rem 0;
    border-radius: 0.5rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        gap: 1rem;
        padding: 0.25rem 0;
    }
`

export const ImageWrapper = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #f0f0f0;
    transition: transform 0.2s ease;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 46px;
        height: 46px;
    }
`

export const ContentContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    border-bottom: 1px dotted ${({ theme }) => theme.colors.tfwBlack10};
    padding-bottom: 0.5rem;
    min-width: 0;

    ${RegionItem}:last-child & {
        border-bottom: none;
        padding-bottom: 0;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding-bottom: 0.625rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding-bottom: 0.75rem;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`

export const Title = styled.div`
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        line-height: 1.5;
    }
`

export const SubTitle = styled.div`
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.tfwBlack40};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        line-height: 1.5;
    }
`

export const IconContainer = styled.div`
    height: 1.25rem;
    width: 1.25rem;
    flex-shrink: 0;
    transition: transform 0.2s ease;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        height: 1.5rem;
        width: 1.5rem;
    }
`

export const ArrowRightIcon = styled(ChevronRightIcon)`
    width: 100%;
    height: 100%;

    & path {
        stroke: #a5a5a5;
        transition: stroke 0.2s ease;
    }
`
